import * as React from 'react'
import { Space, Typography, Input, Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { TauxProperties } from './MainCSoftAccess';
const { Text } = Typography;

interface IProps {
  taux:    TauxProperties
  setTaux: React.Dispatch<React.SetStateAction<TauxProperties>>
}

export default function CTaux(props: IProps){

    return (
      <div>
      <Space style={{width: '100%'}} direction="vertical">
        <div className="div-text-input">
           <Text className='text-before-input'>Nom</Text>
           <Input
              id       = "affichage_taux_affichage_taux_nom"
              style    = {{borderRadius: '4px'}}
              value    = {props.taux.affichage_taux.affichage_taux_nom}
              onChange = {(e) => {
                props.setTaux({
                  ...props.taux,
                  affichage_taux:{
                    ...props.taux.affichage_taux,
                    affichage_taux_nom: e.target.value
                  }
                })
              }}
           />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Formatter en pourcent ?</Text>
          <Radio.Group
            id       = "affichage_taux_affichage_taux_formatter_en_pourcent"
            value    = {props.taux.affichage_taux.affichage_taux_formatter_en_pourcent}
            onChange = {(e: RadioChangeEvent) => {
              props.setTaux({
                ...props.taux,
                affichage_taux:{
                  ...props.taux.affichage_taux,
                  affichage_taux_formatter_en_pourcent: e.target.value
                }
              })
            }}
          >
            <Radio value={true}>Oui</Radio>
            <Radio value={false}>Non</Radio>
          </Radio.Group>
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Suffixe</Text>
          <Input
            id       = "affichage_taux_affichage_taux_suffix"
            name     = "affichage_taux.affichage_taux_suffix"
            style    = {{borderRadius: '4px'}}
            value    = {props.taux.affichage_taux.affichage_taux_suffix}
            onChange = {(e) => {
              props.setTaux({
                ...props.taux,
                affichage_taux:{
                  ...props.taux.affichage_taux,
                  affichage_taux_suffix: e.target.value
                }
              })
            }}
          />
        </div>
      </Space>
      </div>
    )
}
